
export const isNihssScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "nihss";
const NIHSS_ITEM_KEYS = [
  "level_of_Consiousness",
  "loc_questions",
  "loc_commands",
  "best_gaze",
  "visual",
  "facial_palsy",
  "motor_arm_left",
  "motor_arm_right",
  "motor_leg_left",
  "motor_leg_right",
  "limb_ataxia",
  "sensory",
  "best_language",
  "dysarthria",
  "extinction_and_inattention",
];

export const hasNihssAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  for (const k of NIHSS_ITEM_KEYS) {
    const v = data[k];
    if (v == null || v === "") continue;
    const n = typeof v === "number" ? v : Number(v);
    // In this UI, 0 is the default. Any >0 slider value indicates user input.
    if (Number.isFinite(n) && n > 0) return true;
  }

  return false;
};

